import { useController } from 'react-hook-form';
import { BasicFilterSelect, FilterSelectProps, SelectValueType } from 'ui/selects';
import { FieldProps } from './types';

export type BasicFilterSelectFieldProps<TValue extends SelectValueType = string> =
  FieldProps<TValue> &
    Omit<FilterSelectProps<TValue, FilterSelectProps>, 'defaultValues' | 'isError' | 'onSelect'>;

export const BasicFilterSelectField = <TValue extends SelectValueType = string>({
  defaultValue,
  name,
  ...rest
}: BasicFilterSelectFieldProps<TValue>) => {
  const {
    field: { onChange, value },
    fieldState: { error },
  } = useController({
    name,
    defaultValue,
  });

  return (
    <BasicFilterSelect
      {...rest}
      isError={!!error}
      defaultValues={[value]}
      onSelect={([selectedValue]) => {
        onChange(selectedValue);
      }}
    />
  );
};
